import React, { FC } from 'react';
import styles from './info-box.module.sass';

export const InfoBox : FC<React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>> = ({className, ...props}) => {
  return <div {...props} className={`${styles.infoBox} ${className ?? ""}`}>{props.children}</div>
}

export default InfoBox;
